/** all min and max of media query */
export const mobileMediaQuery = "@media (max-width: 470px)";
export const tabletMediaQuery = "@media (max-width: 850px)";
export const desktopMediaQuery = "@media (min-width: 850px)";
export const fullMediaQuery = "@media (min-width: 1440px)";
